import { api } from "./api";
import URI from "./URI";

export const getUserInvestments = () => {
  let options = {
    tokenRequired: true, method: "GET",
    headers: {
      "X-USERINFO": "*"
    }
  }
  return api(URI.userInvestments, options, import.meta.env.VITE_BFF_API_BASE);
};
